import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TRouter } from '@/common/basis/types/trouter';

function App() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='flex h-screen w-screen items-center justify-center'>
      <div>
        <div>
          <img alt='notFound' className='h-60 w-60' src={require('@/common/basis/assets/not_found_pic.png')} />
        </div>
        <div className='mx-auto text-center text-[18px]'>{t('notFoundTips')}</div>
        <div className='mx-auto mb-20 mt-8 flex items-center justify-center'>
          <Button onClick={() => navigate(TRouter.ROUTE_HOME)} size='large' type='primary'>
            <span>{t('home')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default App;
